import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getBusinessInfo } from "redux-context/business";
import { TIKTOK_AUTH_REFRESH_EVENT_KEY } from "constants/tiktok";

const StorageListener: FC = () => {
  const dispatch = useDispatch<any>();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === TIKTOK_AUTH_REFRESH_EVENT_KEY && event.newValue) {
        dispatch(getBusinessInfo());
      }
    };
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [dispatch]);

  return null;
};

export default StorageListener;
